var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-2", class: _vm.parentClass }, [
    _c(
      "div",
      { staticClass: "flex justify-between" },
      [
        _vm.labelShown
          ? _c(
              "label",
              {
                staticClass: "form_group_title",
                class: _vm.titleClasses,
                attrs: { for: _vm.inputId },
              },
              [
                _vm._t("title", function () {
                  return [
                    _c("p", {
                      staticClass: "font-semibold",
                      domProps: { innerHTML: _vm._s(_vm.title) },
                    }),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._t("labelAside"),
      ],
      2
    ),
    _c(
      "div",
      { class: _vm.formInputClass },
      [
        _c(
          "Processing",
          { attrs: { spinner: "", processing: _vm.processing } },
          [
            _c(
              "div",
              { staticClass: "mb-1" },
              [
                _vm._t("default", function () {
                  return [
                    _c("FormInput", {
                      class: _vm.inputClasses,
                      attrs: {
                        id: _vm.inputId,
                        value: _vm.value,
                        name: _vm.name,
                        type: _vm.type,
                        placeholder: _vm.placeholder,
                        disabled: _vm.disabled,
                        debounceTime: _vm.debounceTime,
                        inputClass: _vm.inputClass,
                        height: _vm.height,
                      },
                      on: {
                        input: _vm.handleInput,
                        blur: function ($event) {
                          return _vm.$emit("blur")
                        },
                        enter: function ($event) {
                          return _vm.$emit("enter")
                        },
                      },
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        ),
        _vm.hasErrors
          ? _c(
              "div",
              { staticClass: "ml-1 mb-4" },
              _vm._l(_vm.errors, function (error, index) {
                return _c("FormGroupError", {
                  key: index,
                  attrs: { error: error },
                })
              }),
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }